import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import HomePage from './pages';
import DocsPage from './pages/docs';
import DownloadCenterPage from './pages/downloadCenter';
import PluginDetailPage from './pages/pluginDetail';
import PluginMarketPage from './pages/plugins';
export default function App() {
    return (_jsxs(_Fragment, { children: [_jsx(Header, {}), _jsxs(Routes, { children: [_jsx(Route, { index: true, element: _jsx(HomePage, {}) }), _jsx(Route, { path: "/docs", element: _jsx(DocsPage, {}) }), _jsx(Route, { path: "/download-center", element: _jsx(DownloadCenterPage, {}) }), _jsx(Route, { path: "/plugins", element: _jsx(PluginMarketPage, {}) }), _jsx(Route, { path: "/plugins/:id", element: _jsx(PluginDetailPage, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] })] }));
}
